import { NavLink } from 'react-router-dom'
import { LayoutDashboard, Users, Clock, Settings, Monitor } from 'lucide-react'
import { useAuthStore } from '@/store/authStore'
import clsx from 'clsx'

const BOTTOM_NAV = [
  { to: '/dashboard', label: 'Главная', icon: LayoutDashboard, roles: null },
  { to: '/attendance', label: 'История', icon: Clock, roles: null },
  { to: '/students', label: 'Ученики', icon: Users, roles: ['super_admin', 'admin', 'department_admin', 'viewer', 'operator'] },
  { to: '/devices', label: 'Терминалы', icon: Monitor, roles: ['super_admin', 'admin', 'operator'] },
  { to: '/settings', label: 'Меню', icon: Settings, roles: null },
]

export default function BottomNav() {
  const user = useAuthStore((s) => s.user)
  const userRole = user?.role_detail?.name

  const navItems = BOTTOM_NAV.filter(({ roles }) =>
    !roles || !userRole || roles.includes(userRole)
  ).slice(0, 5) // max 5 items for a bottom bar

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 safe-area-bottom z-40 pb-safe">
      <div className="flex justify-around items-center h-16 px-2">
        {navItems.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              clsx(
                'flex flex-col items-center justify-center w-full h-full space-y-1 transition-colors relative',
                isActive ? 'text-primary-600' : 'text-gray-400 hover:text-gray-600'
              )
            }
          >
            {({ isActive }) => (
              <>
                <div className={clsx("relative p-1 rounded-full transition-all duration-300", isActive && "bg-primary-50")}>
                  <Icon size={22} className={clsx("transition-transform duration-300", isActive && "scale-110")} strokeWidth={isActive ? 2.5 : 2} />
                </div>
                <span className={clsx('text-[10px] font-medium tracking-tight', isActive && 'font-semibold')}>
                  {label}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  )
}
